"use strict";
exports.__esModule = true;
exports.LegendList = exports.LegendSeparator = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var LegendItem_1 = tslib_1.__importDefault(require("./LegendItem"));
var LegendAxisIndicator_1 = require("./LegendAxisIndicator");
var helpers_1 = require("./helpers");
exports.LegendSeparator = function () { return react_1["default"].createElement("div", { className: "legend-separator" }); };
var LegendList = /** @class */ (function (_super) {
    tslib_1.__extends(LegendList, _super);
    function LegendList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendList.prototype.render = function () {
        var _a = this.props, series = _a.series, enableBorderRadius = _a.enableBorderRadius, onItemClick = _a.onItemClick, width = _a.width;
        return series.map(function (item, index) {
            var type = item.type, labelKey = item.labelKey, data = item.data;
            var borderRadius = shouldItemHaveBorderRadius(item, enableBorderRadius);
            if (type === helpers_1.LEGEND_AXIS_INDICATOR) {
                return react_1["default"].createElement(LegendAxisIndicator_1.LegendAxisIndicator, { key: index, labelKey: labelKey, data: data, width: width });
            }
            else if (type === helpers_1.LEGEND_SEPARATOR) {
                return react_1["default"].createElement(exports.LegendSeparator, { key: index });
            }
            else {
                return (react_1["default"].createElement(LegendItem_1["default"], { enableBorderRadius: borderRadius, key: index, item: item, width: width, onItemClick: onItemClick }));
            }
        });
    };
    return LegendList;
}(react_1["default"].PureComponent));
exports.LegendList = LegendList;
function shouldItemHaveBorderRadius(item, enableBorderRadius) {
    if (enableBorderRadius === void 0) { enableBorderRadius = false; }
    if (typeof enableBorderRadius === "function") {
        return enableBorderRadius(item);
    }
    return enableBorderRadius;
}
//# sourceMappingURL=LegendList.js.map